/**
 * ACTOR/ACTION model for Viewer
 */
export class ViewerActorModel {

  /**
   *  InviteId 
   */
  public id!: string;
  /**
   * Person GUID
   */
  public dossierPersonId!: string;
  /**
   * Document GUID
   */
  public documentId!: string;


  /**
   * Name of the Actor
   * - FirstName+Prefix+LastName
   */
  public fullName!: string;
  /**
   * Email
   * - Needed to identify/ cross reference with current user
   */
  public email!: string;
  /**
   * mobile-Phonenumber
   * - Needed to identify/ cross reference with current user
   */
  public mobile!: string;


  /**
   * Order of Actors/Actions
   */
  public order!: number;
  /**
   * Order of Actors/Actions FOR SIDEBAR DRAWING based on position in document
   */
  public sideBarOrder: number = 0;
  /**
   * A FE property only, a way to ASSIGN the number for the Actor
   * This number is than used to display for the side line, action modals, and Action summary
   */
  public badgeNumber: number = 0;

  /**
   * Where the 'Go Back' button navigates To (and if visible) for this Actor
   */
  public redirectUrl: string | null = null;

  /**
  * ActionType
  */
  public action!: string | any;
  /**
   * Whether this Actor/Action is completed
   */
  public actionCompleted!: boolean;
  /**
   * Date when this Actor/Action is completed
   */
  public completionDate!: Date | null;
  /**
   * Deadline of Actor/Action (By Sendgroup)
   */
  public deadline!: Date | null;


  /**
   * Needed for IdentityProvider switching
   */
  public identityProvider!: string;



  /**
   * Sign Action property
   */
  public fieldName!: string;
  /**
   * Sign Action property
   */
  public sigFieldX!: any;
  /**
   * Sign Action property
   */
  public sigFieldY!: any;
  /**
   * Sign Action property
   */
  public sigFieldW!: any;
  /**
   * Sign Action property
   */
  public sigFieldH!: any;
  /**
   * Sign Action property
   */
  public sigFieldPage!: number;

  /**
   * IF an 'Adopt' action, this holds the request properties with the made choice
   */
  public adoptionChoice: boolean = false;



}